import { IWriteOffInfo } from '../../../redux/reducers';
import { IWriteOffInfoSchema } from '../../../repositories/monolith-python/entities/WriteOffInfoSchema';
import { mapWriteOffInfo } from './mapWriteOffInfo';

export function mapWriteOffWithoutDiscountInfo(
  writeOffWithoutDiscountInfo?: IWriteOffInfoSchema | null,
): IWriteOffInfo | null {
  if (!writeOffWithoutDiscountInfo) {
    return null;
  }

  return mapWriteOffInfo(writeOffWithoutDiscountInfo);
}
